import {
  SvgCamera,
  SvgCog6ToothEmpty,
  SvgMapMarker,
  SvgBatchEncoding,
  SvgCreditLeft,
} from "ui/svgs";

import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import clsx from "clsx";
import { PlusIcon } from "@heroicons/react/20/solid";

export default function Table({ data, page }: { data: any; page?: string }) {
  const { orgid, id } = useParams();
  const orgId = orgid ?? id;
  const navigate = useNavigate();
  const location = useLocation();

  // 获取查询参数
  const queryParams = new URLSearchParams(location.search);
  const pageNumber = queryParams.get("page");
  const query = queryParams.get("query");
  return (
    <div className="w-full overflow-x-auto mt-3">
      {data?.data?.map((data: any) => (
        <Link
          to={
            page === "license"
              ? `/dashboard/license/purchase/${data.customer.user.organization.id}/purchase`
              : page === "license-ai"
                ? `/dashboard/license/ai/${data.customer.user.organization.id}`
                : `/dashboard/customers/${data.customer.user.organization.id}/sites?page=${pageNumber || 1}&query=${query || ""}`
          }
          state={{ credits: data?.stats?.remainingCredits || 0 }}
          key={data.customer.user.id}
          className="group"
        >
          <div
            className={clsx(
              "rounded-3xl px-5 py-4 mb-3  text-neutral-700 hover:bg-[#DCE7FD]",
              +data.customer.user.organization.id === +orgId
                ? "bg-[#DCE7FD]"
                : "bg-neutral-100",
            )}
          >
            <div className="flex justify-between mb-2 gap-1">
              <p className="font-medium max-w-[160px] overflow-hidden text-ellipsis text-nowrap">
                {data.customer.accountName}
              </p>
              {page == "customer" && (
                <div className="invisible group-hover:visible">
                  <button
                    className="hover:bg-neutral-200 rounded-full text-neutral-500 p-1"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(
                        `/dashboard/customers/${data.customer.user.organization.id}/sites/create`,
                      );
                    }}
                  >
                    <PlusIcon className="h-5 " />
                  </button>
                  <button
                    className="hover:bg-neutral-200 rounded-full text-neutral-500 p-1"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(
                        `/dashboard/customers/${data.customer.user.organization.id}/encoding?page=${pageNumber || 1}&query=${query || ""}`,
                        { replace: true },
                      );
                    }}
                  >
                    <SvgBatchEncoding
                      width="18"
                      className="fill-neutral-500 "
                    />
                  </button>
                  <button
                    className="hover:bg-neutral-200 rounded-full text-neutral-500 p-1"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(
                        `/dashboard/customers/${data.customer.user.organization.id}/edit?page=${pageNumber || 1}&query=${query || ""}`,
                      );
                    }}
                  >
                    <SvgCog6ToothEmpty width="19" />
                  </button>
                </div>
              )}
              {page == "license-ai" && (
                <div className="flex items-center gap-0.5 flex-shrink-0">
                  <SvgCreditLeft width="12" className="fill-[#222222]" />
                  <p className="font-semibold max-w-24 overflow-hidden text-nowrap text-ellipsis">
                    {data?.stats?.remainingCredits?.toLocaleString()}
                  </p>
                  <span>left</span>
                </div>
              )}
            </div>
            <div className="text-sm">
              <span className="mr-4">
                <SvgMapMarker
                  width="14"
                  className="fill-neutral-500 inline-block mr-1 relative -top-[3px]"
                />
                Site: {data.stats.siteNum}
              </span>
              <span>
                <SvgCamera
                  width="19"
                  className="fill-neutral-500 inline-block mr-1 relative -top-[3px]"
                />
                <span>Online / Offline:</span>{" "}
                <span className="text-emerald-500">
                  {data.stats.onlineCamNum}
                </span>{" "}
                /{" "}
                <span className="text-red-600">{data.stats.offlineCamNum}</span>
              </span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}
